import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { RubroService } from 'src/app/services/rubro.service';
import { FamiliaService } from 'src/app/services/familia.service';
import * as _ from 'lodash';
import { CheckinCheckoutService } from 'src/app/services/checkin-checkout.service';
import { RutService } from 'src/app/shared/services/rut.service';

@Component({
  selector: 'app-checkin-checkout',
  templateUrl: './checkin-checkout.component.html',
  styleUrls: ['./checkin-checkout.component.scss'],
  providers: [SecurityService],
})
export class CheckinCheckoutComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private detalle_currentPayload: any = null;
  private resumen_currentPayload: any = null;

  //Lista resumen
  resumen_listaMovimientos: Array<any> = null;
  resumen_listaMovimientosAll: Array<any> = null;
  resumen_paginationContext: PaginationContext = new PaginationContext();
  // resumen_totales: any = null;

  //Lista detalle
  detalle_listaMovimientos: Array<any> = null;
  detalle_listaMovimientosAll: Array<any> = null;
  detalle_paginationContext: PaginationContext = new PaginationContext();

  //Options
  optionsVendedor: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];
  // Utils
  private log: any;
  resumen_loading: boolean = false;
  detalle_loading: boolean = false;
  loadingExcel: boolean;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rubroService: RubroService,
    private vendedorService: VendedorService,
    private checkService: CheckinCheckoutService,
    private rutService: RutService,
    private familiaService: FamiliaService
  ) {
    this.log = this.clog.log('REP. VTAS. CHECK IN/OUT');
    this.loadingExcel = false;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10;
    this.detalle_paginationContext.RecordsByPage = 10;

    this.loadVendedores();
    // this.loadRubros();
    this.createForm();
    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    // this.formHeader.get('rubros').valueChanges.subscribe((rubro: string) => {
    //   this.onRubroSelect(rubro);
    // });
    // this.formHeader.get('tipoVista').valueChanges.subscribe((tipoVista: string) => {
    //   if (tipoVista === this.RB_TIPO_VISTA_RESUMEN) {
    //     this.formHeader.get('vendedores').setValue([]);
    //   }
    // });
    const range = 31;
    this.formHeader.get('fechaDesde').valueChanges.subscribe((fechaDesde: string) => {
      console.log('fechaDesde', fechaDesde);
      if (!fechaDesde) {
        const { initDate } = this.datesService.GetStartAndCurrentMonthToISO();
        this.formHeader.get('fechaDesde').setValue(initDate);
      } else {
        const fechaHasta = this.formHeader.get('fechaHasta').value;
        const result = this.datesService.validRangeDate(fechaDesde, fechaHasta, range);
        this.validarResultFecha(result);
      }
    });
    this.formHeader.get('fechaHasta').valueChanges.subscribe((fechaHasta: string) => {
      console.log('fechaHasta', fechaHasta);
      if (!fechaHasta) {
        const { currentDate } = this.datesService.GetStartAndCurrentMonthToISO();
        this.formHeader.get('fechaHasta').setValue(currentDate);
      } else {
        const fechaDesde = this.formHeader.get('fechaDesde').value;
        const result = this.datesService.validRangeDate(fechaDesde, fechaHasta, range);
        this.validarResultFecha(result);
      }
    });
  }

  validarResultFecha(result: boolean) {
    if (!result) {
      this.formHeader.get('fechaDesde').setErrors({ invalidRange: true });
      this.formHeader.get('fechaHasta').setErrors({ invalidRange: true });
    } else {
      this.formHeader.get('fechaDesde').setErrors(null);
      this.formHeader.get('fechaHasta').setErrors(null);
    }
  }

  focusInput(input: string) {
    const element = document.getElementById(input);
    if (element) element.focus();
  }

  get fechaDesdeValue() {
    return this.formHeader.get('fechaDesde').value;
  }
  get fechaHastaValue() {
    return this.formHeader.get('fechaHasta').value;
  }

  /**
   * Oculta la columna "Vendedor" cuando el filtro tiene exactamente un vendedor
   * (es redundante). Si no hay filtro o hay varios, la columna se muestra.
   * mdb-select con [multiple] a veces emite un único valor escalar en vez de [valor].
   */
  mostrarColumnaVendedorEnDetalle(): boolean {
    const vendedoresCtrl = this.formHeader.get('vendedores');
    const raw = vendedoresCtrl != null ? vendedoresCtrl.value : null;
    const sel = this.normalizarSeleccionVendedoresFiltro(raw);
    if (sel.length === 0) {
      return true;
    }
    if (sel.length === 1) {
      return false;
    }
    return true;
  }

  private normalizarSeleccionVendedoresFiltro(value: unknown): unknown[] {
    if (value == null) {
      return [];
    }
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  }

  onRubroSelect(ev) {
    this.optionsFamilia = [];

    const listaRubros = this.formHeader.get('rubros').value;
    if (!listaRubros) return;

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i]);
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubroReporteVenta(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
      this.optionsFamilia = this.optionsFamilia.concat(options);
    });
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor })).sort((a, b) => a.label.localeCompare(b.label));
    });
  }

  private loadRubros() {
    this.rubroService.obtenerRubrosReporteVenta(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
    });
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      vendedores: [[]],
      // rubros: [[]],
      // familias: [[]],
      producto_sin_sku: true,
    });
    // this.configurarDatetimePicker();
  }
  // configurarDatetimePicker() {
  //   const hoy = new Date();
  //   const initDate = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().slice(0, -1);
  //   const currentDate = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), hoy.getHours(), hoy.getMinutes(), 0, 0).toISOString().slice(0, -1);
  //   this.formHeader.get('fechaDesde').setValue(initDate);
  //   this.formHeader.get('fechaHasta').setValue(currentDate);
  // }

  LimpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonthToISO();
    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_RESUMEN);
    this.formHeader.get('vendedores').setValue([]);
    // this.formHeader.get('rubros').setValue([]);
    // this.formHeader.get('familias').setValue([]);
    // this.formHeader.get('producto_sin_sku').setValue(true);
    this.resumen_listaMovimientos = null;
    this.resumen_listaMovimientosAll = null;
    this.detalle_listaMovimientos = null;
    this.detalle_listaMovimientosAll = null;
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber);
    this.detalleBuscar(pageNumber);
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.resumen_loading = true;

    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.resumen_loading = false;
      return;
    }

    this.resumen_paginationContext.CurrentPage = pageNumber;

    this.resumen_listaMovimientos = null;
    this.resumen_listaMovimientosAll = null;

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, producto_sin_sku } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor: vendedores,
        // listaRubro: rubros,
        // listaFamilia: familias,
        // producto_sin_sku,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.resumen_paginationContext.RecordsByPage
    };
    this.resumen_currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.checkService.obtenerReporteVentasCheckResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        if (!mensajes || !mensajes.some(m => m && m.texto)) {
          this.toastService.error('Error al obtener el reporte de resumen. Por favor intente nuevamente.', 'Error');
        }
        this.resumen_loading = false;
        return;
      }

      const { registros } = respuesta;
      this.resumen_listaMovimientosAll = registros;
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length; //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage); //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1;
      this.resumen_loading = false;

      this.showPageResumen(this.resumen_paginationContext.CurrentPage);
      // this.calculateTotalesResumen()
    });
  }
  // calculateTotalesResumen() {
  //   this.resumen_totales = {
  //     neto_total: _.sumBy(this.resumen_listaMovimientosAll, 'neto_total')
  //   }
  // }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    this.loadingExcel = true;
    const inputParams = _.cloneDeep(this.resumen_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.checkService.obtenerReporteVentasCheckResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        if (!mensajes || !mensajes.some(m => m && m.texto)) {
          this.toastService.error('Error al generar el archivo. Por favor intente nuevamente.', 'Error');
        }
        this.loadingExcel = false;
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      this.loadingExcel = false;
    });
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber;
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage;
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage);
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage);
  }

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.detalle_loading = false;
      return;
    }

    this.detalle_paginationContext.CurrentPage = pageNumber;

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, producto_sin_sku } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor: vendedores,
        // listaRubro: rubros,
        // listaFamilia: familias,
        // producto_sin_sku,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.detalle_paginationContext.RecordsByPage
    };
    this.detalle_currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.detalle_loading = true;
    this.detalle_listaMovimientos = null;
    this.detalle_listaMovimientosAll = null;

    this.checkService.obtenerReporteVentasCheckDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        const hayMensajes = mensajes && mensajes.some(m => m && m.texto);
        if (!hayMensajes) {
          this.toastService.error('Error al obtener el reporte de detalle. Por favor intente nuevamente.', 'Error');
        }
        this.detalle_loading = false;
        return;
      }

      const { registros } = respuesta;
      this.detalle_listaMovimientosAll = registros;
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length; //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage); //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1;
      this.detalle_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage);
      // this.calculateTotalesDetalles()
      this.detalle_loading = false;
    });
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    this.loadingExcel = true;
    const inputParams = _.cloneDeep(this.detalle_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.checkService.obtenerReporteVentasCheckDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        if (!mensajes || !mensajes.some(m => m && m.texto)) {
          this.toastService.error('Error al generar el archivo. Por favor intente nuevamente.', 'Error');
        }
        this.loadingExcel = false;
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      this.loadingExcel = false;
    });
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber;
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage;
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage);
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage);
  }
}
